module.exports = {"broadcasters":["AVRO","AVROTROS","BNN","BNNVARA","BOS","EO","HUMAN","Human","IKON","KRO","KRO-NCRV","MAX","NCRV","NOS","NPO Zapp","NPS","NTR","PowNed","TROS","VARA","VPRO","WNL"]}


//////////////////
// WEBPACK FOOTER
// ./src/components/data/broadcasters.json
// module id = 7CPY
// module chunks = 1